// drawer/components/ThreatActorsComponent.tsx
import { InfoTag } from '@praetorian-chariot/ui';

import { OverflowText } from '@/components/OverflowText';
import { Table } from '@/components/table/Table';
import { Section } from '@/sections/threats/components';
import type {
  EnrichedVulnerability,
  ThreatActor,
} from '@/sections/threats/types';

interface ThreatActorsComponentProps {
  threatIntel?: EnrichedVulnerability;
}

/**
 * Threat actors table component
 */
export function ThreatActorsComponent({
  threatIntel,
}: ThreatActorsComponentProps) {
  const { threat_actors = [] } = threatIntel ?? {};

  return (
    <Section title="Threat Actors">
      {threat_actors.length === 0 && (
        <p className="text-sm">No known threat actors in our data feeds</p>
      )}
      {threat_actors.length > 0 && (
        <Table<ThreatActor>
          name="threat_actors"
          status="success"
          columns={[
            { label: 'Name', id: 'name' },
            {
              label: 'Alias',
              id: 'aliases',
              cell: item => {
                const aliases = item.aliases?.join(', ');
                return <OverflowText text={aliases || '-'} />;
              },
            },
            {
              label: 'Country',
              id: 'country',
              fixedWidth: 100,
              cell: item => item.country || '-',
            },
            {
              label: 'Categories',
              id: 'categories',
              cell: item => (
                <div className="mt-2 flex flex-wrap gap-2">
                  {item.categories.map(category => (
                    <InfoTag
                      size="xs"
                      className="space-x-0"
                      key={category}
                      label={category}
                      icon={null}
                    />
                  ))}
                  {item.categories.length === 0 && '-'}
                </div>
              ),
            },
          ]}
          data={threat_actors}
          error={null}
          selection={{ hide: true }}
        />
      )}
    </Section>
  );
}
